import React from "react";
import { ReactComponent as Remove } from "../../../assets/icons/remove.svg";

/**
 * @param {Object} options
 * @param {(e: React.MouseEvent, id: string) => void} options.onRemove
 */
export function getHomecareListColumns({ onRemove }) {
  return [
    {
      id: "name",
      accessorKey: "name",
      header: "Homecare Name",
      cell: ({ row }) => (
        <span >{row.original?.name ?? "—"}</span>
      ),
    },
    {
      id: "postcode",
      accessorKey: "postcode",
      header: "Postcode",
      cell: ({ row }) => (
        <span className="block">{row.original?.postcode ?? "—"}</span>
      ),
    },
    {
      id: "remove",
      header: "Remove",
      enableSorting: false,
      cell: ({ row }) => (
        <div
          className="flex justify-end"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          role="presentation"
        >
          <Remove
            className="cursor-pointer"
            onClick={(e) => onRemove(e, row.original.connected_user_id)}
            data-testid={`homecare-remove-${row.original.connected_user_id}`}
          />
        </div>
      ),
      meta: { disableFilterMenu: true, align: "right" },
    },
  ];
}
